var render, staticRenderFns
import script from "./DragAndDropWrapper.vue?vue&type=script&lang=js&"
export * from "./DragAndDropWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6add5ea0')) {
      api.createRecord('6add5ea0', component.options)
    } else {
      api.reload('6add5ea0', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Components/DragAndDrop/DragAndDropWrapper.vue"
export default component.exports